import React from 'react'
import IonIcon from '@reacticons/ionicons'

const AccessRestrictedOverlay = ({content}) => {
  return (
    <div className='absolute inset-0 z-50 backdrop-blur-[4px] rounded-[16px] bg-white/40 flex items-center justify-center'>
      <div className='text-center px-4 py-6 bg-white/60 backdrop-blur-md max-w-[500px] rounded-xl shadow-[0_4px_12px_0_rgba(0,0,0,0.15)]'>
        <IonIcon
          name='lock-closed-outline'
          className='text-[24px] mb-2 text-[#7C50DD]'
        />
        <h2 className='text-xl font-semibold mb-2'>Access Restricted</h2>
        <p className='text-sm text-gray-700 mb-4'>
          {content}
        </p>
        <a href='/subscription'>
          <button className='bg-[#7C50DD] rounded-full font-medium text-[12px] px-6 py-2 text-white cursor-pointer shadow hover:shadow-lg transition-all duration-200'>
            Upgrade Now
          </button>
        </a>
      </div>
    </div>
  )
}

export default AccessRestrictedOverlay
